import { render, staticRenderFns } from "./CustomerDiscountProductsPrintReport.vue?vue&type=template&id=0783f4e8&scoped=true&"
import script from "./CustomerDiscountProductsPrintReport.vue?vue&type=script&lang=js&"
export * from "./CustomerDiscountProductsPrintReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDiscountProductsPrintReport.vue?vue&type=style&index=0&id=0783f4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783f4e8",
  null
  
)

export default component.exports